module.exports = __webpack_public_path__ + "img/Jaime_Torrealba_Cubillos.5c29caf8.jpg";